export default __webpack_public_path__ + "static/media/tmp_banner_image03.480510bf.png";